<template>
  <wa-page
    :view-slug="`${isReleased() ? 'icon-pack-landing' : 'icon-pack-landing icon-pack-landing-prerelease'} icon-pack-landing-${iconPack()?.name}`"
    :custom-style="viewStyle"
  >
    <wa-page-header
      slot="header"
      key="header"
      theme-color="var(--theme-action-primary)"
      is-inverted
    />

    <main
      slot="content"
      class="app-content padding-bottom-7xl"
      role="main"
    >
      <wa-icons-loading v-if="isLoading()" />
      <template v-else>
        <pack-hero />

        <section
          id="about-pack"
          class="padding-top-5xl padding-bottom-2xl"
        >
          <div class="container">
            <div class="row align-stretch">
              <div class="display-none tablet:display-block tablet:column-6 tablet:padding-right-2xl laptop:column-4">
                <pack-icon-design-showcase
                  :is-highlighting-icon-design-canvas="isHighlightingIconDesignCanvas"
                  :is-highlighting-icon-design-grid="isHighlightingIconDesignGrid"
                />
              </div>

              <div class="order-first column-12 tablet:column-6 laptop:column-7 laptop:margin-bottom-0 laptop:offset-1">
                <pack-about />
              </div>
            </div>

            <pack-actions
              key="pack-actions"
              :is-for-smaller-viewports="true"
            />

            <div class="margin-top-3xl">
              <pack-specs @toggleIconDesign="toggleIconDesign" />
            </div>
          </div>
        </section>

        <pack-playground v-if="isReleased()" />
        <pack-mockups />
        <pack-icons v-if="isReleased()" />
        <pack-related />
      </template>
    </main>

    <wa-page-footer slot="footer" />
  </wa-page>
</template>

<script>
  import PackAbout from '../components/PackAbout'
  import PackActions from '../components/PackActions'
  import PackHero from '../components/PackHero'
  import PackIconDesignShowcase from '../components/PackIconDesignShowcase'
  import PackIcons from '../components/PackIcons'
  import PackMockups from '../components/PackMockups'
  import PackPlayground from '../components/PackPlayground'
  import PackRelated from '../components/PackRelated'
  import PackSpecs from '../components/PackSpecs'

  export default {
    name: 'TemplatePack',

    components: {
      PackAbout,
      PackActions,
      PackHero,
      PackIconDesignShowcase,
      PackIcons,
      PackMockups,
      PackPlayground,
      PackRelated,
      PackSpecs
    },

    inject: ['iconPack', 'isLoading', 'isReleased'],

    data() {
      return {
        isHighlightingIconDesignGrid: false,
        isHighlightingIconDesignCanvas: false
      }
    },

    computed: {
      isThemeMonochromatic() {
        return !this.iconPack()?.theme?.accent
      },

      viewStyle() {
        let style = {}

        style['--theme-action-primary'] = this.iconPack()?.theme?.primary || ''
        style['--theme-action-primary-dk'] = this.iconPack()?.theme?.primaryDark || ''
        style['--theme-button-hover-border-color'] = this.iconPack()?.theme?.primaryDark || ''
        style['--theme-hero-background'] = this.iconPack()?.theme?.heroBackground || ''
        style['--theme-background'] = this.iconPack()?.theme?.background || ''
        style['--theme-title-color'] = this.iconPack()?.theme?.primaryDark || ''
        style['--theme-icon-design-path-color'] = this.iconPack()?.theme?.primaryDark || ''

        if (this.isThemeMonochromatic) {
          style['--theme-action-accent'] = 'var(--fa-gravy)'
          style['--theme-action-accent-dk'] = 'var(--fa-dk-gravy)'
          style['--theme-button-hover-background'] = this.iconPack()?.theme?.primary || ''
          style['--theme-nav-accent'] = this.iconPack()?.theme?.primary || ''
          style['--theme-title-tag-color'] = this.iconPack()?.theme?.primary || ''
          style['--theme-icon-design-fill-color'] = this.iconPack()?.theme?.primary || ''
        } else {
          style['--theme-action-accent'] = this.iconPack()?.theme?.accent || ''
          style['--theme-action-accent-dk'] = this.iconPack()?.theme?.accentDark || ''
          style['--theme-button-hover-background'] = this.iconPack()?.theme?.accent || ''
          style['--theme-nav-accent'] = this.iconPack()?.theme?.accent || ''
          style['--theme-title-tag-color'] = this.iconPack()?.theme?.accent || ''
          style['--theme-icon-design-fill-color'] = this.iconPack()?.theme?.accent || ''
        }

        return style
      }
    },

    methods: {
      toggleIconDesign(value) {
        const target = `isHighlightingIconDesign${value}`
        this[target] = !this[target]
      }
    }
  }
</script>
